import React from 'react';
import { Text } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';

export default function ConfirmationTitle(props) {
  return <Text size="lg">{props.message}</Text>;
}

ConfirmationTitle.propTypes = {
  message: PropTypes.string,
};
